import React from 'react';
import { Switch, FormControl, Text } from '@contentful/f36-components';

interface MoqSelectorProps {
  moq: boolean;
  onChangeMoq: (value: boolean) => void;
}

export const MoqSelector = ({ moq, onChangeMoq }: MoqSelectorProps): React.JSX.Element => {
  return (
    <FormControl>
      <Switch
        id="moq-toggle"
        name="moq-toggle"
        isChecked={moq}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChangeMoq(e.target.checked)}
      >
        <Text>Include only products with no minimum order quantity (MOQ = 1)</Text>
      </Switch>
    </FormControl>
  );
};
